import LocalizedStrings from 'localized-strings';

interface TransfersHomeLocales {
  availableInHigherPlan: string;
  bulkTransfer: string;
  bulkTransferDescription: string;
  international: string;
  internationalTransferDescription: string;
  oneOffSepaTransfer: string;
  oneOffSepaTransferDescription: string;
  title: string;
  walletToWallet: string;
  walletToWalletDescription: string;
}

const locales = new LocalizedStrings<TransfersHomeLocales>({
  en: {
    availableInHigherPlan: 'Available from Shine {planName}',
    bulkTransfer: 'In Euro (grouped)',
    bulkTransferDescription:
      'Make up to 100 transfers at once using an XML or CSV file',
    international: 'In foreign currency',
    internationalTransferDescription: 'Send money in foreign countries.',
    oneOffSepaTransfer: 'In Euro',
    oneOffSepaTransferDescription: 'Send money to one of your beneficiaries',
    title: 'Transfer money',
    walletToWallet: 'Between your Shine wallets',
    walletToWalletDescription:
      'Transfer money instantly and without limit between your wallets.',
  },
  fr: {
    availableInHigherPlan: 'Disponible à partir de Shine {planName}',
    bulkTransfer: 'En euro (groupé)',
    bulkTransferDescription:
      'Réalisez jusqu’à 100 virements en une fois à l’aide d’un fichier XML ou CSV',
    international: 'En devise étrangère',
    internationalTransferDescription: 'Envoyez de l’argent à l’international.',
    oneOffSepaTransfer: 'En euro',
    oneOffSepaTransferDescription:
      "Transférez de l'argent à l'un de vos bénéficiaires en euro.",
    title: 'Effectuez un virement',
    walletToWallet: 'Entre vos comptes Shine',
    walletToWalletDescription:
      'Transférez de l’argent entre vos comptes en instantané et illimité.',
  },
} as const);

export default locales;
